module.exports = __webpack_public_path__ + "img/examples-ru-6.4c16546b.jpg";